import { Box, useScrollTrigger, Zoom } from '@mui/material';

import { hasWindow } from 'utils/browser.utils';

import Icon from 'components/@icons/Icon';

const ScrollToTop = () => {
  const trigger = useScrollTrigger({
    target: hasWindow() ? window : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Zoom in={trigger}>
      <Box
        component="button"
        onClick={handleClick}
        role="button"
        aria-label="back to top"
        sx={{
          zIndex: 1,
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'common.white',
          color: 'common.black',
          border: '1px solid',
          borderColor: 'grey.200',
          position: 'fixed',
          cursor: 'pointer',
          bottom: 120,
          right: 50,
        }}
      >
        <Icon name="ArrowUp" fontSize={20} />
      </Box>
    </Zoom>
  );
};

export default ScrollToTop;
